import moment from 'moment';

export default class FiltersModel {
    
    gender= ''
    nextAvailabilityAfter= ''
    nextAvailabilityBefore= ''
    name= ''
    languageId= ''
    lgbtq= ''
    religion= ''
    ethnicity= ''
    struggleIds= []

    constructor(filters) {
        if(!filters) 
            return

        this.gender = filters.gender
        this.nextAvailabilityAfter = filters.nextAvailabilityAfter
        this.nextAvailabilityBefore = filters.nextAvailabilityBefore
        this.name = filters.name
        this.languageId = filters.languageId
        this.lgbtq = filters.lgbtq
        this.religion = filters.religion
        this.struggleIds = filters.struggleIds
        this.ethnicity = filters.ethnicity;
    }

    toPayload() {
        
        const filters = {}

        if (this.name) {
            filters.name = this.name;
        }

        if (this.gender) {
            filters.gender = this.gender;
        }

        if (this.nextAvailabilityAfter) {
            filters.nextAvailableAfter = moment(
                this.nextAvailabilityAfter
            )
            .endOf('day')
            .toISOString();
        }

        if (this.nextAvailabilityBefore) {
            filters.nextAvailableBefore = moment(
                this.nextAvailabilityBefore
            )
            .startOf('day')
            .toISOString();
        }

        if (this.struggleIds && this.struggleIds.length) {
            filters.struggleIds = this.struggleIds.map((s) => s.id);
        }

        if(this.lgbtq) {
            filters.lgbtq = this.lgbtq
        }

        if(this.languageId){
            filters.languageId = this.languageId
        }

        if(this.religion){
            filters.religion = this.religion
        }
        
        if(this.ethnicity){
            filters.ethnicity = this.ethnicity
        }

        return filters;
    }
}